import './App.css';
import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useSwipeable } from 'react-swipeable';




function Main({ title, text, image, isCurrent, onClick }) {

  const isMobile = useMediaQuery({ query: `(max-width: 1132px)` });

  return (
    <div className='page' id={title} isCurrent={isCurrent} style={{display: isCurrent ? 'flex' : 'none', opacity: isCurrent ? '1' : '0'}}>
      <div className='text-column'>{text}</div>
      <div className='image-column'><div className='frame'><img onClick={onClick} style={{width: '100%', aspectRatio: '1440 / 900', cursor: 'pointer'}} src={image} alt="Image"></img></div></div>
    </div>
  );
}


export default Main